<template>
    <AccountViewBase :account="account" :loading="loading" :error="error">
        <CompaniesManager :mode="mode" :audienceId="audienceId" :customProspectOptions="customProspectOptions" />
    </AccountViewBase>
</template>

<script>
    import { mapState, mapActions } from 'pinia';
    import AccountViewBase from '@/views/account/AccountViewBase';
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import accountMixin from '@/mixins/accountMixin';
    import CompaniesManager from '@/components/account/companies/CompaniesManager';
    import { useAudienceStore } from '@/stores/audience';
    import { useCompaniesStore } from '@/stores/companies';

    export default {
        name: 'AudienceCompaniesView',
        components: {
            AccountViewBase,
            CompaniesManager
        },
        mixins: [i18nViewMixin, accountMixin],
        props: {
            mode: {
                type: String,
                required: false
            },
            audienceId: {
                type: String,
                required: false
            },
            prospectOptions: {
                type: String,
                required: false,
                default: null
            }
        },
        data() {
            return {
                seo_title: 'views.companies.seo_title',
                seo_title_data: null,
                customProspectOptions: null
            };
        },
        computed: {
            ...mapState(useCompaniesStore, {
                companiesMode: 'mode'
            }),
            ...mapState(useAudienceStore, {
                audience: 'audience',
                audienceLoading: 'loading'
            }),
            loading() {
                return this.accountLoading || this.audienceLoading;
            }
        },
        methods: {
            ...mapActions(useAudienceStore, ['getAudience']),
            generateSeoTitle() {
                switch (this.companiesMode) {
                    case 'new':
                        if(this.audience?.name) {
                            this.seo_title = 'views.audience_suspects.seo_title';
                            this.seo_title_data = {
                                name: this.audience.name
                            };
                        } else {
                            this.seo_title = 'views.suspects.seo_title';
                        }
                        break;
                    case 'prospects':
                        if(this.audience?.name) {
                            this.seo_title = 'views.audience_prospects.seo_title';
                            this.seo_title_data = {
                                name: this.audience.name
                            };
                        } else {
                            this.seo_title = 'views.prospects.seo_title';
                        }
                        break;
                    default:
                        if(this.audience?.name) {
                            this.seo_title = 'views.audience_companies.seo_title';
                            this.seo_title_data = {
                                name: this.audience.name
                            };
                        } else {
                            this.seo_title = 'views.companies.seo_title';
                        }
                        break;
                }
                this.updateDocumentTitle();
            },
            async updateAudience(id) {
                const result = await this.getAudience(id, this.$router);

                if (result) {
                    this.generateSeoTitle();
                }
            },
            parseProspectOptions() {
                if (this.prospectOptions) {
                    try {
                        this.customProspectOptions = JSON.parse(this.prospectOptions);
                        const query = { ...this.$route.query };
                        delete query.prospectOptions;
                        
                        this.$router.replace({
                            path: this.$route.path,
                            query: Object.keys(query).length ? query : undefined
                        });
                    } catch {
                        this.customProspectOptions = null;
                    }
                } else {
                    this.customProspectOptions = null;
                }
            }
        },
        watch: {
            companiesMode: 'generateSeoTitle',
            audienceId: {
                async handler(newVal) {
                    if (newVal) {
                        await this.updateAudience(newVal);
                    }
                },
                immediate: true
            },
            prospectOptions: {
                handler: 'parseProspectOptions',
                immediate: true
            }
        }
    }
</script>